import React from "react";
import "./Policies.css";

function Refund() {
  return (
    <div className="policy-container">
      <h1>Payments & Refund Policy</h1>

      <div className="payment-card">
        <h3>Bank Details</h3>
        <div className="bank-info">
          <p>
            <strong>Beneficiary Account Name:</strong> ATLAS Travel House
          </p>
          <p>
            <strong>Account Number:</strong> 922020062015487
          </p>
          <p>
            <strong>Bank Name:</strong> AXIS BANK
          </p>
          <p>
            <strong>IFSC Code:</strong> UTIB0000207
          </p>
          <p>
            <strong>Branch:</strong> Janakpuri
          </p>
          <p>
            <strong>Account Type:</strong> Current Account
          </p>
          <p>
            <strong>Branch Address:</strong> New Delhi
          </p>
        </div>
      </div>

      <div className="policy-section">
        <h3>Payment Policy</h3>
        <p>
          We may provide paid products and/or services within the Service. In
          that case, we use third-party services for payment processing (e.g.
          payment processors). We will not store or collect your payment card
          details. That information is provided directly to our third-party
          payment processors, whose use of your personal information is governed
          by their Privacy Policy. These payment processors adhere to the
          standards set by PCI-DSS as managed by the PCI Security Standards
          Council, which is a joint effort of brands like Visa, Mastercard,
          American Express and Discover. PCI- DSS requirements help ensure the
          secure handling of payment information.
        </p>
      </div>

      <div className="policy-section">
        <h3>Refund Policy</h3>
        <p>
          How regularly have you made a flight setting up for the web, missed
          getting it and dreaded the confounded airplane undoing approaches more
          than truly feeling horrendous about not making the trip? That is the
          time when I picked, no more. Having investigated at long last and
          tended to travel masters, I have comprehended that it's less difficult
          than you may presume. Offering this naturally found astuteness to
          everyone. Exhaustively the abrogation courses of action material on
          airfare in India are: For most airships, abrogation sales should be
          set at any rate three hours before the booked departure of the flight
          In extension to the date change cost, any toll differentiation is paid
          by the customer In a couple of cases, a scratch-off and rebooking
          might be more affordable than choosing a date change. The airships
          don't limit or change the money if the new affirmation you are
          rebooking to is more affordable than the one that you as of late held
          Cancellation cost compasses depending on the transporter you've booked
          with When leaving the country, make sure to take travel assurance
          which spreads dropping conditions Following 30 days of ticket wiping
          out the cash will be discounted.{" "}
        </p>
      </div>

      <div className="policy-section">
        <h3>The most effective method to Cancel a Reservation?</h3>
        <p>
          We will process your demise/markdown request inside one to seven
          business days. We won't perceive any verbal/by means of phone sales or
          voice messages. Verbally conversing with our customer bolster
          delegates without adjusting a sales structure won't guarantee that
          your scratch-off has been arranged or perceived. We won't recognize
          email withdrawals aside from in the event that they have an aggregate,
          stamped, and annexed Cancellation Form. Cancellation must be made by
          adjusting and denoting the ATLAS TRAVEL HOUSE Cancellation Request
          Form. In the event that it's not all, that much issue explain why you
          are referencing a revocation. You should download the Cancellation
          Request Form here.
        </p>
      </div>

      <div className="policy-section">
        <h3>Cancellation Made Within -</h3>
        <p>
          6 days prior to departure 7-15 Days Prior to Departure Date 16-24 Days
          Prior to Departure Date 25 or more Days Prior to Departure Date{" "}
        </p>
      </div>
      <div className="policy-section">
        <h3>Correction Fees:</h3>
        <p>
          Any movements made to a booking after adequately introducing the
          solicitation on the web and 7 days before the visit pulls back for
          single day and 24 days before the visit leaves for multi day visits
          will be needy upon a base Amendment Fee (per change). Reservations
          will be confirmed inside one to two business days. The going with set
          up as a change to a visit: Changing departure date Changing get time
          or region Changing visit Changing guest name Changing plan
          Removing/Replacing a guest Adding/Replacing a guest The modification
          cost is a base visit change charge. If you request various movements
          just as sales the progressions finally, additional charges may apply
          (despite the modification cost). Paying the amendment cost doesn't
          guarantee a change can or will be made. Note: Each airplane has
          express wiping out guidelines. Visit the official flying machine site
          for further nuances. Since you have the retraction procedures
          impeccably clear, why worry over neglecting to get that plane or
          perhaps.Go ahead and value the ride.{" "}
        </p>
      </div>
    </div>
  );
}

export default Refund;
